import Box from '@mui/material/Box';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import * as React from 'react';

export interface CountedTextFieldProps extends Omit<MuiTextFieldProps, 'type'> {
  maxLength?: number;
  type?: 'text';
}

const CountedTextField = React.forwardRef<HTMLInputElement, CountedTextFieldProps>(
  function CountedTextField(
    { maxLength, onFocus, onBlur, onChange, helperText, slotProps, type = 'text', ...rest },
    ref
  ): JSX.Element {
    if (!maxLength) {
      throw new Error('maxLength is required');
    }
    if (type !== 'text') {
      throw new Error('invalid input type');
    }

    const [value, setValue] = React.useState('');
    const mergedSlotProps = {
      ...(slotProps ?? {}),
      htmlInput: {
        ...(slotProps?.htmlInput ?? {}),
        maxLength,
      },
    };

    const handleChange = (event: any) => {
      setValue(event.target.value);
      onChange?.(event);
    };

    const currentLen = value === undefined || value === null ? 0 : String(value).length;

    return (
      <MuiTextField
        ref={ref}
        {...rest}
        type={type}
        value={value}
        slotProps={mergedSlotProps}
        onFocus={(event) => onFocus?.(event)}
        onBlur={(event) => onBlur?.(event)}
        onChange={handleChange}
        helperText={
          <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{helperText}</span>
            <span>{`${currentLen} / ${maxLength}`}</span>
          </Box>
        }
      />
    );
  }
);

CountedTextField.displayName = 'CountedTextField';

export default CountedTextField;
